
export const SUPPLY_PARTNER = 'supply-partner';
export const DEMAND_PARTNER = "demand-partner";
export const SUPPLY = "supply";
export const DEMAND = "demand";
export const ROUTES = "routes";


export const reportTypes = [
    { label: 'Supply', field: SUPPLY },
    { label: 'Demand', field: DEMAND },
    { label: 'Routes', field: ROUTES },
    { label: 'Supply Partner', field: SUPPLY_PARTNER },
    { label: 'Demand Partner', field: DEMAND_PARTNER },
];
